import axios from 'axios';

const getStaticPage = (pageName, callback) => axios.get(`/api/static/pages/${pageName}.html`)
  .then(response => callback(response.data))
  .catch(error => console.log(error));

export default getStaticPage;
